import { request } from "../request";

// 获取当前段的弹题列表
export const getInteractionList = (params) =>
  request(`/v1/interaction/list`, "get", { params }); // {lesson_id}

// 上报弹题触发
export const postInteractionTrigger = (params) =>
  request(`/v1/interaction/trigger`, "post", { json: params }); // {interaction_id}

// 提交作答
export const postInteractionAnswer = (params) =>
  request(`/v1/interaction/answer`, "post", { json: params }); // {interaction_id, answer, duration_ms}

// 跳过
export const postInteractionSkip = (params) =>
  request(`/v1/interaction/skip`, "post", { json: params }); // {interaction_id}
